import { DashboardLayout } from '@/components/layout/DashboardLayout';
import { CompanySettings as CompanySettingsComponent } from '@/components/settings/CompanySettings';
import LiquidityDeliverySchedule from '@/components/settings/LiquidityDeliverySchedule';
import { TransferRulesSettings } from '@/components/settings/TransferRulesSettings';
import OnChainSettings from '@/components/settings/OnChainSettings';
import RunwayInputCard from '@/components/compliance/RunwayInputCard';
import { FXSettings } from '@/components/settings/FXSettings';
import { HistoricalFXCard } from '@/components/settings/HistoricalFXCard';
import { FXForecastCard } from '@/components/settings/FXForecastCard';
import { ShareClassManagement } from '@/components/settings/ShareClassManagement';
import { useTenantStore } from '@/hooks/useTenantStore';

export default function CompanySettings() {
  const { tenantId } = useTenantStore();

  return (
    <DashboardLayout>
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold">Company Settings</h1>
          <p className="text-muted-foreground mt-1">
            Configure company-wide settings and preferences
          </p>
        </div>
        <CompanySettingsComponent />
        {tenantId && <ShareClassManagement companyId={tenantId} />}
        {tenantId && <RunwayInputCard companyId={tenantId} />}
        <FXSettings />
        <HistoricalFXCard />
        <FXForecastCard baseCurrency="USD" companyId={tenantId || undefined} />
        {tenantId && <TransferRulesSettings companyId={tenantId} />}
        {tenantId && <OnChainSettings companyId={tenantId} />}
        <LiquidityDeliverySchedule />
      </div>
    </DashboardLayout>
  );
}
